<script setup>
import SetPasswd from "../../lib/login/views/SetPasswd.vue";
import { useFetch, useHttp } from "vutil";
import { useRouter } from "vue-router";
import { ref } from "vue";

const setPasswd = ref(false);
const router = useRouter();
const { data: user, error: getError } = useFetch("/api/user");
const { busy, error: patchError, patch } = useHttp(() => router.push({ name: 'home' }));
</script>

<template>
	<div class="error">{{ getError }}</div>
	<form v-if="user" @submit.prevent="patch('/api/user', user)">
		<fieldset :disabled="busy">
			<label for="email">Email</label>
			<input id="email" v-model.trim="user.email" type="email" readonly>
			<label for="name">Name</label>
			<input id="name" v-model.trim="user.name" type="text" required>
			<div class="error">{{ patchError }}</div>
			<button type="submit" class="ui">Update</button>
			<button type="button" class="ui outlined" style="margin-left: 16px" @click="setPasswd = true">Change Password</button>
		</fieldset>
	</form>
	<UiDialog v-if="setPasswd" style="width: 400px" @close="setPasswd = false">
		<SetPasswd :email="user.email" @login="setPasswd = false"/>
	</UiDialog>
</template>
